export interface PointerLockState {
  locked: boolean;
  yawDelta: number;   // accumulated since last poll
  pitchDelta: number;
}

export function createPointerLock(canvas: HTMLCanvasElement): {
  state: PointerLockState;
  request: () => void;
  poll: () => { dx: number; dy: number };
} {
  const state: PointerLockState = { locked: false, yawDelta: 0, pitchDelta: 0 };

  document.addEventListener("pointerlockchange", () => {
    state.locked = document.pointerLockElement === canvas;
  });

  document.addEventListener("mousemove", (e) => {
    if (!state.locked) return;
    state.yawDelta += e.movementX;
    state.pitchDelta += e.movementY;
  });

  canvas.addEventListener("click", () => {
    if (!state.locked) canvas.requestPointerLock();
  });

  return {
    state,
    request: () => canvas.requestPointerLock(),
    poll: () => {
      const dx = state.yawDelta;
      const dy = state.pitchDelta;
      state.yawDelta = 0;
      state.pitchDelta = 0;
      return { dx, dy };
    },
  };
}
